import React from 'react';

export const themes = {
    browse: {
        background: '#0336FF',
        color: '#fff'
    },
    learn: {
        background: '#ff0266',
        color: '#212121'
    }
}

export const ThemeContext = React.createContext({theme: themes.browse, changeTheme: ()=>{} })